export default __webpack_public_path__ + "img/illustration.1abcf9fd.svg";